/**
 * /auth/no-access — terminal denial for a signed-in caller with no dink
 * product-admin grant. It NEVER auto-redirects to login: the whole point of
 * this screen is to stop the sign-in loop. Re-authentication is a deliberate
 * user action.
 */
import { Box, Button, Stack, Typography } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';
import { clearDeepLink, redirectToCentralizedLogin } from '@/auth/silentRefresh';

export function NoAccess() {
  const { t } = useCopy();

  function signInAgain(): void {
    clearDeepLink();
    redirectToCentralizedLogin('/');
  }

  return (
    <Box
      role="alert"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        px: 2,
      }}
    >
      <Stack spacing={2} sx={{ alignItems: 'center' }}>
        <Typography variant="h2" component="h1">
          {t('auth.noAccessTitle', "You don't have access to this console")}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 480 }}>
          {t(
            'auth.noAccessBody',
            'Your account is signed in but has not been granted access to this product admin console. Contact your administrator if you believe this is a mistake.',
          )}
        </Typography>
        <Button variant="outlined" onClick={signInAgain}>
          {t('auth.signInAgain', 'Sign in again')}
        </Button>
      </Stack>
    </Box>
  );
}
